// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Yxef","icon":"styles_icon__1eCyN"};